import { createFileRoute } from '@tanstack/react-router';
import { ForecastOccurrenceForm } from '@/pages/forecast/occurrence/form';
import { PROTECTED, FORECAST } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${FORECAST}`;

export const Route = createFileRoute(
  '/protected/_layout/forecast/_layout/planning/new'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: NewForecastOccurrenceModal,
});

function NewForecastOccurrenceModal() {
  const { duplicateFromId } = Route.useSearch();
  return (
    <ForecastOccurrenceForm
      returnUrl={RETURN_URL}
      duplicateFromId={duplicateFromId ?? undefined}
    />
  );
}
